module.exports = __webpack_public_path__ + "img/peiicon2.bf76c3a4.svg";